// Operator-Login — interner Betreiber-Zugang (Marc + Sandro).

import { useState, type FormEvent } from "react";

import { Button } from "@/components/Button";

import { login } from "./api";
import { setOperatorSession } from "./session";

export function OperatorLoginPage({ onLogin }: { onLogin: () => void }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    if (!email.trim() || !password) return;
    setBusy(true);
    setError(null);
    try {
      setOperatorSession(await login(email.trim(), password));
      onLogin();
    } catch {
      setError("E-Mail oder Passwort falsch.");
      setPassword("");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="op-shell op-center">
      <form className="op-login" onSubmit={submit}>
        <div className="op-brand op-brand-lg">
          Fidena <span className="op-brand-tag">Operator</span>
        </div>
        <p className="op-login-sub">Interner Betreiber-Zugang</p>

        <label className="op-label">
          E-Mail
          <input
            className="op-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoFocus
            autoComplete="username"
            required
          />
        </label>
        <label className="op-label">
          Passwort
          <input
            className="op-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
        </label>

        {error && <p className="op-error">{error}</p>}

        <Button
          variant="primary"
          type="submit"
          loading={busy}
          disabled={!email.trim() || !password}
          style={{ width: "100%", justifyContent: "center" }}
        >
          Anmelden
        </Button>
      </form>
    </div>
  );
}
